import { useSiteMedia } from "@/context/SiteMediaContext";

export const ButterflyIcon = ({ className = "w-9" }) => {
  const { logo } = useSiteMedia();
  return <img src={logo} alt="Studio Carolina Aguiar" className={`${className} object-contain inline-block`} />;
};
